export default {
  fallbackLng: 'en',
  defaultNS: 'common',
  // Languages the admin UI itself is translated into (drives UI language
  // detection). Keep this list in lockstep with the fully-translated locale
  // folders under public/locales — a locale here must have ALL namespaces.
  supportedLngs: ['en', 'fr', 'de', 'es', 'pt-PT'],
  // Languages we can render customer-facing subscription CONTENT in (selling
  // plan names / options, registered via the Shopify Translations API). This is
  // deliberately a superset of `supportedLngs`: a store can operate in a
  // language we have plan-name strings for (e.g. Italian) even though our admin
  // dashboard isn't fully translated into it. A locale here only needs the
  // `app.plans.details` namespace file. See app/i18n/contentI18next.server.ts.
  contentSupportedLngs: ['en', 'fr', 'de', 'es', 'pt-PT', 'it'],
};
